import queries from '@apis/queries';
import useProjectId from '@hooks/useProjectId';
import { itemActions } from '@store/item/itemSlice';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

interface Props {
    itemId: string;
    shopId: string;
}

function usePrepareOrder({ itemId, shopId }:Props) {
  const dispatch = useDispatch();
  const projectId = useProjectId();
  const { data: item } = useQuery(queries.items.detail(itemId));
  const { data: shop } = useQuery(queries.shop.detail(shopId));

  useEffect(() => {
    if (shop && item) {
      dispatch(itemActions.prepare({ shop, items: [item], projectId }));
    }
  }, [projectId, shop, item]);
}

export default usePrepareOrder;
